module.exports = __webpack_public_path__ + "components/promo-premium/static/mountain-pro__logo--white-a50d7fab9e7ded7234ad06a8ee094801.svg";